import React from 'react';
import clsx from 'clsx';
import { Product, ProductTag } from '@interfaces/models/product';
import useActiveDealQuery from '@hooks/deal/use-active-deal-query';
import styles from './product-tags.module.scss';

type ProductTagsProps = {
  product: Product;
};
const ProductTags: React.FC<ProductTagsProps> = ({ product }): React.JSX.Element => {
  const { activeDeal } = useActiveDealQuery();

  const activeDealExists = activeDeal?.active && product?.flags?.includes('deal-eligible');

  if (!activeDealExists && !product?.tags?.length) {
    return null;
  }

  return (
    <div className={styles.productTags}>
      {activeDealExists && (
        <span
          className={clsx(styles.productTags__tag, styles['productTags__tag--deal'])}
          style={{
            color: activeDeal?.textColor,
            backgroundColor: activeDeal?.backgroundColor,
          }}
        >
          {activeDeal.localizedName}
        </span>
      )}
      {!activeDealExists && (
        <>
          {(product?.tags ?? []).map((tag: ProductTag) => (
            <span
              key={tag}
              className={styles.productTags__tag}
            >
              {tag === 'welove' && 'We Love'}
              {tag === 'vintage' && 'Vintage'}
            </span>
          ))}
        </>
      )}
    </div>
  );
};

export default ProductTags;
